import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

export default defineNuxtRouteMiddleware(async (to, from) => {
  await authStore.getUserIp();
});
